/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateCategoryAction, UpdateCategoryActionTypes, UpdateCategoryState } from './types';

export const initialUpdateCategoryState: UpdateCategoryState = {
  loading: false,
  success: false,
  error: null,
};

export default function updateCategoryReducer(
  state = initialUpdateCategoryState,
  action: UpdateCategoryAction,
): UpdateCategoryState {
  switch (action.type) {
    case UpdateCategoryActionTypes.UPDATE_CATEGORY:
      return update(state, {
        loading: { $set: true },
      });

    case UpdateCategoryActionTypes.UPDATE_CATEGORY_SUCCESS:
      return update(state, {
        loading: { $set: false },
        success: { $set: true },
      });

    case UpdateCategoryActionTypes.UPDATE_CATEGORY_ERROR:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
      });

    case UpdateCategoryActionTypes.CLOSE_UPDATE_CATEGORY_SUCCESS_POPUP:
      return update(state, {
        success: { $set: false },
      });

    case UpdateCategoryActionTypes.RESET_UPDATE_CATEGORY_ERROR:
      return update(state, {
        error: { $set: null },
      });

    default:
      return state;
  }
}
